/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { Dictionary } from "@insite/client-framework/Common/Types";
import { get } from "@insite/client-framework/Services/ApiService";
import {ApiParameter} from "@insite/client-framework/Services/ApiService";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { CatalogPageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface CustomGetProductByPathApiV2Parameter extends GetProductByPathApiV2Parameter {
    queryStringParameters?: Dictionary<any>;
    cache?: RequestInit["cache"];
}

const catalogPagesUrl = "/api/v1/catalogpages";
const productsUrl = "/api/v2/products";
const groupByAttributesUrl = "api/ppsc/product/groupByAttributes";

// XNG-Change: create new method that allows us to set query strings and cache on get request.
export async function getProductByPath(parameter: CustomGetProductByPathApiV2Parameter) {
    const result = await get<CatalogPageModel>(`${catalogPagesUrl}`, { path: parameter.path } as ApiParameter);
    const productModel = await get<ProductModel>(
        `${productsUrl}/${result.productId}`, 
        {
            expand: parameter.expand,
            additionalExpands: parameter.additionalExpands,
            includeAttributes: parameter.includeAttributes,
            addToRecentlyViewed: parameter.addToRecentlyViewed,
        } as ApiParameter, 
        parameter?.queryStringParameters, 
        parameter?.cache,
    );

    return productModel;
}

export async function getGroupByAttributes(parameter: any) {
    const result = await get(`${groupByAttributesUrl}`, parameter);
    return result;
}